import React from 'react'
import {SettingRoleContextProvider} from './../context/SettingRoleContext'
import SettingRolePage from './SettingRolePage'

function SettingRoleContainer() {
    return <section className="SettingRoleContainer">
        <SettingRoleContextProvider>
            <SettingRolePage/>
        </SettingRoleContextProvider>
    </section>
}

export default SettingRoleContainer
